(function () {
  var accountId = 1344984;
  var attributeName = 'maxmind_tracking_token';
  var trackingToken = null;
  var saveQueue = Promise.resolve();
  var trackingTimeout;

  function saveToken(token) {
    // Serialize the initial and checkout token writes.
    saveQueue = saveQueue.then(async function () {
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 5000);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      try {
        var response = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { [attributeName]: token } }),
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Cart attribute update failed');
        var cart = await response.json();
        if (!cart.attributes || cart.attributes[attributeName] !== token) {
          throw new Error('Cart attribute was not confirmed');
        }
        return true;
      } catch (error) {
        console.warn('[MaxMind] Device token could not be saved to the cart.', error);
        return false;
      } finally {
        clearTimeout(timeout);
      }
    });
    return saveQueue;
  }

  var tracking = Promise.race([
    import('https://device.maxmind.com/js/device-module.js')
      .then(function (module) { return module.trackDevice({ accountId: accountId }); })
      .then(function (result) {
        return result && typeof result.trackingToken === 'string' && result.trackingToken
          ? result.trackingToken : null;
      }),
    new Promise(function (resolve) {
      trackingTimeout = setTimeout(function () { resolve(null); }, 5000);
    })
  ]).catch(function (error) {
    console.warn('[MaxMind] Device tracking is unavailable.', error);
    return null;
  }).then(function (token) {
    clearTimeout(trackingTimeout);
    trackingToken = token;
    if (token) saveToken(token);
    return token;
  });

  window.NCGMaxMindDevice = {
    ensureSaved: async function () {
      var token = await tracking;
      if (!token) return false;
      // A cart clear/re-add can occur after the first save; refresh at checkout.
      return saveToken(trackingToken);
    }
  };
})();
